import FormNavigator from "./FormNavigator"

export default FormNavigator

export { PageProps } from './types.d'